// removed by extract-text-webpack-plugin
module.exports = {"modal":"Modal__modal___9QpxU","overlay":"Modal__overlay___26LpG","inner":"Modal__inner___2Kfcq","title":"Modal__title___RQatk","description":"Modal__description___3Uptv","buttons":"Modal__buttons___3sPOr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.scss
// module id = 1231
// module chunks = 1